import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Breadcrumb, Col, Row } from "react-bootstrap";

interface PageTitleProps {
  title: string;
  name?: string;
  subName?: string;
}

const PageBreadcrumb = ({ title, name, subName }: PageTitleProps) => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{title} | Codefox - Responsive Tailwind Admin Dashboard</title>
        </Helmet>
      </HelmetProvider>
      {name && (
        <Row>
          <Col xs={12}>
            <div className="page-title-box">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <Breadcrumb.Item as='span'>Codefox</Breadcrumb.Item>
                  <Breadcrumb.Item>{subName}</Breadcrumb.Item>
                  <Breadcrumb.Item active>{name}</Breadcrumb.Item>
                </ol>
              </div>
              <h4 className="page-title">{name}</h4>
            </div>
          </Col>
        </Row>
      )}
    </>
  )
}

export default PageBreadcrumb;